import { COLORS } from '@constants';
import { CAMPAIGN_STATUS } from '@enums';

export const getCampaignStatusColor = (status, isWaitingForProducts = false) => {
    // "Waiting for products" should look like a Live campaign (green), so use the ACTIVE color.
    if (isWaitingForProducts) {
        return COLORS.$robinBlue;
    }

    switch (status) {
        case CAMPAIGN_STATUS.ACTIVE:
            return COLORS.$robinBlue;
        case CAMPAIGN_STATUS.PAUSED:
            return COLORS.$gray40Black;
        case CAMPAIGN_STATUS.DELETED:
            return COLORS.$gray20Black;
        case CAMPAIGN_STATUS.PRE_LAUNCHED:
            return COLORS.$yellow;
        default:
            return COLORS.$gray60Black;
    }
};
